import React, { useState } from 'react';
import { Clock, Star, Trophy, Heart, Shield, Sparkles, Activity } from 'lucide-react';
import { servicesEquin, servicesCanin, whyMassage } from '../mockData';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';

const Services = () => {
  const [activeTab, setActiveTab] = useState('equin');

  const iconComponents = {
    trophy: Trophy,
    heart: Heart,
    shield: Shield,
    sparkles: Sparkles,
    activity: Activity
  };

  const scrollToPricing = () => {
    const element = document.getElementById('pricing');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="services" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#8B9E8A] mb-4">
            Mes Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Des soins professionnels adaptés aux besoins de vos chevaux et chiens
          </p>
        </div>

        {/* Why Massage Section */}
        <div className="mb-20">
          <h3 className="text-3xl font-bold text-center text-[#8B9E8A] mb-12">
            Pourquoi le massage animalier ?
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {whyMassage.map((benefit, index) => {
              const IconComponent = iconComponents[benefit.icon];
              return (
                <Card key={index} className="border-[#C5A572]/20 hover:shadow-xl transition-all duration-300 hover:scale-105 bg-white">
                  <CardHeader>
                    <div className="mb-3">
                      <IconComponent className="text-[#C5A572] w-10 h-10" />
                    </div>
                    <CardTitle className="text-[#8B9E8A] text-xl">{benefit.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-gray-600">{benefit.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>

        {/* Services Tabs */}
        <div className="max-w-6xl mx-auto">
          <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
            <TabsList className="grid w-full grid-cols-2 mb-8 bg-[#8B9E8A]/10">
              <TabsTrigger 
                value="equin"
                className="data-[state=active]:bg-gradient-to-r data-[state=active]:from-[#8B9E8A] data-[state=active]:to-[#9CAF88] data-[state=active]:text-white font-semibold text-lg py-3"
              >
                🐴 Prestations Équines
              </TabsTrigger>
              <TabsTrigger 
                value="canin"
                className="data-[state=active]:bg-gradient-to-r data-[state=active]:from-[#8B9E8A] data-[state=active]:to-[#9CAF88] data-[state=active]:text-white font-semibold text-lg py-3"
              >
                🐕 Prestations Canines
              </TabsTrigger>
            </TabsList>

            <TabsContent value="equin" className="mt-8">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {servicesEquin.map((service) => (
                  <Card key={service.id} className="border-[#C5A572]/30 hover:shadow-xl transition-all duration-300 hover:scale-105 bg-white group">
                    <CardHeader>
                      <div className="flex justify-between items-start mb-2">
                        <CardTitle className="text-[#8B9E8A] text-lg group-hover:text-[#9CAF88] transition-colors">
                          {service.title}
                        </CardTitle>
                        <span className="text-2xl font-bold text-[#C5A572]">{service.price}</span>
                      </div>
                      <CardDescription className="flex items-center gap-2 text-gray-500">
                        <Clock size={16} />
                        {service.duration}
                      </CardDescription>
                    </CardHeader>
                    <CardContent>
                      <p className="text-gray-600">{service.description}</p>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </TabsContent>

            <TabsContent value="canin" className="mt-8">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {servicesCanin.map((service) => (
                  <Card key={service.id} className="border-[#C5A572]/30 hover:shadow-xl transition-all duration-300 hover:scale-105 bg-white group">
                    <CardHeader>
                      <div className="flex justify-between items-start mb-2">
                        <CardTitle className="text-[#8B9E8A] text-lg group-hover:text-[#9CAF88] transition-colors">
                          {service.title}
                        </CardTitle>
                        <span className="text-2xl font-bold text-[#C5A572]">{service.price}</span>
                      </div>
                      <CardDescription className="flex items-center gap-2 text-gray-500">
                        <Clock size={16} />
                        {service.duration}
                      </CardDescription>
                    </CardHeader>
                    <CardContent>
                      <p className="text-gray-600">{service.description}</p>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </TabsContent>
          </Tabs>
        </div>

        {/* CTA to Pricing */}
        <div className="text-center mt-16">
          <button
            onClick={scrollToPricing}
            className="bg-gradient-to-r from-[#C5A572] to-[#B8860B] text-white px-8 py-4 rounded-full font-bold text-lg hover:shadow-xl transition-all duration-300 hover:scale-105 inline-flex items-center gap-2"
          >
            <Star size={24} />
            Découvrir mes Forfaits
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;
